var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcIconMissionH6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "z8d1obstka",
    d: "M0 65h62V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62 29.607c0 16.352-13.88 29.607-31 29.607-17.12 0-31-13.255-31-29.607C0 13.256 13.88 0 31 0c17.12 0 31 13.256 31 29.607",
    fill: "#E1F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 65c-8.748 0-16.942-3.298-23.073-9.287a1.342 1.342 0 0 1-.035-1.88 1.3 1.3 0 0 1 1.854-.034c5.64 5.51 13.188 8.544 21.254 8.544 8.046 0 15.579-3.02 21.214-8.503a1.297 1.297 0 0 1 1.854.037c.502.53.484 1.372-.038 1.88C47.905 61.717 39.727 65 31 65M6.327 47.477h27.819V36.601H.919a28.921 28.921 0 0 0 5.408 10.876",
    fill: "#529AFC"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "gnstkoe60b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#z8d1obstka"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A3D2EF",
    mask: "url(#gnstkoe60b)",
    d: "M35.338 47.478h2.577V36.6h-2.577zM39.108 47.478h2.577V36.6h-2.577z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.084 18.628c.354-3.267-.903-7.024-2.546-9.11-2.558-3.253-9.148-4.48-13.096-1.288-3.948 3.192-3.758 9.594-1.198 12.846 1.469 1.867 4.74 3.363 8.006 3.695 0 0-.31 6.096 5.55 7.426 5.86 1.332 7.679-.238 9.734 4.404 0 0 1.927-3.639.399-11.69-.312-1.637-.984-3.214-2.09-4.45-1.101-1.232-2.713-2.337-4.759-1.833",
    fill: "#FFF",
    mask: "url(#gnstkoe60b)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIconMissionH6);
export default __webpack_public_path__ + "static/media/ic-icon-mission-h-6.817675310905c28175daec61679eab37.svg";
export { ForwardRef as ReactComponent };